import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@/components/atoms";
import { DataTable, DataTableColumnDef } from "@/components/molecules";
import { DailyHireInterval } from "@/redux/slices/pricing/types";
import { DailyHireTableData } from "./types";

interface DailyHireTableProps extends React.HTMLAttributes<HTMLDivElement> {
  intervals: DailyHireInterval[];
  currencySymbol: string;
}

export const DailyHireTable = ({ intervals, currencySymbol, className, ...props }: DailyHireTableProps) => {
  const navigate = useNavigate();

  const data = intervals.map(
    (i) =>
      ({
        time: `${i.minimumRange}+ Day hire`,
        pricePerDay: `${currencySymbol}${i.rate}`,
      } as DailyHireTableData)
  );

  const columns: DataTableColumnDef<DailyHireTableData>[] = [
    {
      accessorKey: "time",
      header: "Time",
      size: 350,
      enableSorting: false,
    },
    {
      accessorKey: "pricePerDay",
      header: "Price per day",
      enableSorting: false,
    },
  ];

  const rowStyles = "  mt-4";

  return (
    <div className={className} {...props}>
      <div className="flex items-center">
        <div className="flex-1">
          <Typography variant="h3" className="leading-8">
            Daily Hire Fees
          </Typography>
          <Typography className="text-neutral-dark-gray">Set the pricing for the daily hire bookings</Typography>
        </div>
        <div className="flex-shrink-0">
          <Button startIcon="Edit2" onClick={() => navigate("edit")} className="bg-primary px-6 hover:bg-primary-dark">
            Edit
          </Button>
        </div>
      </div>
      <DataTable columns={columns} data={data} className={rowStyles} />
    </div>
  );
};
